import { Error } from '@pos/interfaces/cashdro-api-response-interface';

export default class CashdroErrorHelper {
  genericError(): Error {
    return {
      msg: 'payment_terminals.cashdro.error_message.cashdro_generic_exception',
      reason: 'cashdro_generic_exception',
    };
  }

  cashdroConnectionError(): Error {
    return {
      msg: 'payment_terminals.cashdro.error_message.cashdro_connection_exception',
      reason: 'cashdro_connection_exception',
    };
  }

  cashdroAuthenticationError(): Error {
    return {
      msg: 'payment_terminals.cashdro.error_message.cashdro_authentication_exception',
      reason: 'cashdro_authentication_exception',
    };
  }

  cashdroOperationInExecutionError(): Error {
    return {
      msg: 'payment_terminals.cashdro.error_message.cashdro_operations_in_execution_exception',
      reason: 'cashdro_operations_in_execution_exception',
    };
  }

  cashdroOperationWithAmountChangeNotAvailableError(): Error {
    return {
      msg:
        'payment_terminals.cashdro.error_message.cashdro_operation_with_amount_change_not_available_error_exception',
      reason: 'cashdro_operation_with_amount_change_not_available_error_exception',
    };
  }

  cashdroOperationDoesNotExistException(): Error {
    return {
      msg: 'payment_terminals.cashdro.error_message.cashdro_operation_does_not_exist_exception',
      reason: 'cashdro_operation_does_not_exist_exception',
    };
  }

  cashdroIncorrectAmountError(): Error {
    return {
      msg: 'payment_terminals.cashdro.error_message.cashdro_incorrect_amount_exception',
      reason: 'cashdro_incorrect_amount_exception',
    };
  }

  cashdroUserDoesNotHavePermissionError(): Error {
    return {
      msg:
        'payment_terminals.cashdro.error_message.cashdro_user_does_not_have_permission_exception',
      reason: 'cashdro_user_does_not_have_permission_exception',
    };
  }

  cashdroInvalidParametersError(): Error {
    return {
      msg: 'payment_terminals.cashdro.error_message.cashdro_invalid_parameters_exception',
      reason: 'cashdro_invalid_parameters_exception',
    };
  }

  cashdroSystemBusyError(): Error {
    return {
      msg: 'payment_terminals.cashdro.error_message.cashdro_system_busy_exception',
      reason: 'cashdro_system_busy_exception',
    };
  }

  cashdroCanNotStartOperationError(): Error {
    return {
      msg: 'payment_terminals.cashdro.error_message.cashdro_can_not_start_operation_exception',
      reason: 'cashdro_can_not_start_operation_exception',
    };
  }

  cashdroServiceStoppedError(): Error {
    return {
      msg: 'payment_terminals.cashdro.error_message.cashdro_service_stopped_exception',
      reason: 'cashdro_service_stopped_exception',
    };
  }

  cashdroOperationWithError(): Error {
    return {
      msg: 'payment_terminals.cashdro.error_message.cashdro_operation_with_error_exception',
      reason: 'cashdro_operation_with_error_exception',
    };
  }
  cashdroBusyWithOtherOperationError(): Error {
    return {
      msg:
        'payment_terminals.cashdro.error_message.cashdro_busy_with_other_operation_error_exception',
      reason: 'cashdro_busy_with_other_operation_error_exception',
    };
  }

  cashdroOperationIsNotInExecutionError(): Error {
    return {
      msg:
        'payment_terminals.cashdro.error_message.cashdro_operation_is_not_in_execution_exception',
      reason: 'cashdro_operation_is_not_in_execution_exception',
    };
  }

  cashdroUnitTermilansWithAlersError(): Error {
    return {
      msg: 'payment_terminals.cashdro.error_message.cashdro_unit_terminal_with_alerts',
      reason: 'cashdro_unit_terminal_with_alerts',
    };
  }

  cashdroIsEmptyOfCash(): Error {
    return {
      msg: 'payment_terminals.cashdro.error_message.cashdro_is_empty_of_cash',
      reason: 'cashdro_is_empty_of_cash',
    };
  }
}
